export enum PermissionObject {
  Request = 'transportrequest',
  Auction = 'auction',
  Transport = 'transport',
  Carrier = 'carrier',
  Address = 'address',
  Workspace = 'workspace',
  User = 'user',
  Document = 'document',
  Invitation = 'workspaceinvitation',
  Tender = 'tender',
  Contract = 'contract',
  VehicleType = 'vehicletype',
  CargoCategory = 'cargocategory',
  Route = 'route',
  CarrierGroup = 'carriergroup',
  Role = 'role',
  Bid = 'bid',
  TimeSlotBooking = 'timeslotbooking',
  BookingLink = 'bookinglink',
  AddressTimeSlotSettings = 'addresstimeslotsettings',
}

export const permissionObjectPrefix: Record<PermissionObject, string> = {
  [PermissionObject.Request]: 'logistics',
  [PermissionObject.Transport]: 'auctions',
  [PermissionObject.Auction]: 'auctions',
  [PermissionObject.Carrier]: 'directory',
  [PermissionObject.Address]: 'directory',
  [PermissionObject.Workspace]: 'directory',
  [PermissionObject.User]: 'users',
  [PermissionObject.Invitation]: 'invitations_contrib',
  [PermissionObject.Document]: 'documents',
  [PermissionObject.Tender]: 'contracts',
  [PermissionObject.Contract]: 'contracts',
  [PermissionObject.VehicleType]: 'directory',
  [PermissionObject.CargoCategory]: 'directory',
  [PermissionObject.Route]: 'directory',
  [PermissionObject.CarrierGroup]: 'directory',
  [PermissionObject.Role]: 'users',
  [PermissionObject.Bid]: 'bids',
  [PermissionObject.TimeSlotBooking]: 'time_slots',
  [PermissionObject.BookingLink]: 'time_slots',
  [PermissionObject.AddressTimeSlotSettings]: 'time_slots',
}

export enum PermissionType {
  Create = 'add',
  Read = 'view',
  Update = 'change',
  Delete = 'delete',
}

export interface Permissions {
  create: boolean
  update: boolean
  delete: boolean
  read: boolean
}
